import { connect } from 'react-redux';
import { AuthRequired as Auth } from '../components/Common/Login/AuthRequired';
import {
  getLoginState,
  getLoginEmail,
  getLoginPositions,
  getLoginTime,
  execLogin,
  execLogout,
} from '../state/auth';

const mapStateToProps = state => {
  return {
    login: getLoginState(state),
    login_email: getLoginEmail(state),
    login_positions: getLoginPositions(state),
    login_time: getLoginTime(state),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onLogin: (email, password) => dispatch(execLogin(email, password)),
    onLogout: () => dispatch(execLogout()),
  };
};

export const AuthRequired = connect(mapStateToProps, mapDispatchToProps)(Auth);

